import React from "react";
import cookie from "js-cookie";
import axios from "axios";
import windowSize from "react-window-size";
import {
  InfoBox,
  Input,
  Image,
  Row,
  Column,
  Button,
  Text,
} from "../../globalComponents";
import Logo from "../../assets/logos/Main_Logo.png";
import Page_Background from "../../assets/Page_Background.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

class Login extends React.Component {
  state = {
    email: "",
    password: "",
    error: { name: "", text: "" },
  };
  request = () => {
    this.setState({ loading: true });
    if (!this.state.email)
      this.setState({
        loading: false,
        error: { name: "email", text: "Required" },
      });
    else
      axios
        .post("/user/reset", {
          email: this.state.email,
        })
        .then((res) => {
          if (res.data.success) {
            this.setState(
              { error: { name: "", text: "" }, loading: false },
              this.props.history.push("/newPassword")
            );
          } else
            this.setState({
              error: { name: "general", text: res.data.error },
              loading: false,
            });
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            error: { name: "general", text: "Server Error Try Again" },
            loading: false,
          });
        });
  };
  render() {
    const { email, password, error, loading } = this.state;
    const mobile = this.props.windowWidth < 1000;

    return (
      <Column>
        <img
          src={Page_Background}
          style={{
            position: "fixed",
            height: "100vh",
            minWidth: "100vw",
            zIndex: -1,
          }}
        />
        <InfoBox
          padding="0"
          margin="10vh auto auto auto"
          borderRadius="20px"
          maxWidth="600px"
          width={mobile ? "75vw" : "45vw"}
        >
          <Column width="100%">
            <Button
              position="relative"
              margin=".5%"
              width="5%"
              onClick={() => this.props.history.push("/login")}
            >
              <FontAwesomeIcon
                style={{ margin: "auto 5% auto auto" }}
                icon={faArrowLeft}
              />
              Back
            </Button>
            <Image
              margin="-5% auto auto auto"
              src={Logo}
              height={mobile ? "20vw" : "10vw"}
            />
            <Text size="120%" margin="-5% auto 2% auto">
              Aviary
            </Text>
          </Column>
          <Input
            label="Email"
            value={email}
            error={error.name === "email" ? error.text : ""}
            height="6vh"
            width={"70%"}
            onChange={(v) => this.setState({ email: v })}
          />
          <Text margin="auto" color="red">
            {error.name == "general" && error.text}
          </Text>
          <Button
            width={"70%"}
            loading={loading}
            margin="3% auto 3% auto"
            onClick={this.request}
          >
            Request Reset
          </Button>
        </InfoBox>
      </Column>
    );
  }
}
export default windowSize(Login);
